export function railsEnv() {
  return document.querySelector('meta[name="rails-env"]')?.content
}

// The frontend key reports into the production AppSignal app.
// Leave it off in development so local errors stay local.
export function frontendErrorsEnabled(env = railsEnv()) {
  return env !== "development"
}

export function contextTags() {
  const tags = {}
  const userId = document.querySelector('meta[name="userId"]')?.content
  const companyId = document.querySelector('meta[name="companyId"]')?.content
  if (userId) tags.user_id = String(userId)
  if (companyId) tags.company_id = String(companyId)
  return tags
}

export function decorateWithContext(span) {
  const tags = contextTags()
  if (Object.keys(tags).length === 0) return span
  return span.setTags(tags)
}
